declare var cmn_schemeName: string;
declare var cmn_cartDomain: string;
declare function GetCustomerName();


let host = location.host;
let TestSite = ['aemtest.com', 'store-rev.modd.com'];


$(function () {
    let $body = $('body');
    let bodyId = $body.attr('id');

    if (bodyId === 'Register') {
        pageRegister();
    } else if (bodyId === 'RegisterStep1') {
        RegisterStep1();
    } else if (bodyId === 'MyPage') {
        MyPage();
    } else if (bodyId === 'fcJoinEntry') {
        fcJoinEntry()
    } else if (bodyId === 'fc_help') {
        // ご利用ガイド
        fcHelp()
    } else if (bodyId === 'Login') {
        // ログイン
        login()
    } else if(bodyId == 'CustomerEdit') {
        //会員情報変更
        CustomerEdit();
    } else if(bodyId == 'fc_contact') {
        // お問い合わせ
        fcContact();
    } else if (bodyId == 'PassEdit') {
        // パスワード変更
        PassEdit();
    } else if (bodyId == 'PassforgotStep1') {
        // パスワード再設定
        PassforgotStep1();
    }


    if (bodyId === 'ShoppingCart') {
        // カートページのロゴの切り替え処理
        loadCartSetting();
    }


    // 会員規約を利用規約にかえる
    // プライバシーポリシーのリンク先を変える
    setTimeout(function(){
        $('#contents a').each(function() {

            if($(this).text().indexOf('会員規約') > -1) {
                $(this).text('利用規約');
            }

            if($(this).text().indexOf('プライバシーポリシー') > -1) {
                $(this).attr("href", "").attr('href', '//www.axelentermedia.co.jp/privacy/');
            }

        })
    }, 500)

});


// プライバシーポリシーのURL変更
$(function () {
    $('#cmnfoot_button_privacy').removeClass('link_autorep').attr({href: 'https://www.axelentermedia.co.jp/privacy/' , target:'_blank'});
});

// Register
function pageRegister() {
    // $('.tblbody_email .table_control').prepend('<div class="mb-20"><a href="" target="_blank">【利用規約】</a>にご同意の上、メールアドレスを入力してください。</div>');
}

// RegisterStep1
function RegisterStep1() {
    // $('.table_label.col_must').each(function(){
    //     let $title = $(this);

    //     if($title.text().indexOf('郵便番号') > -1) {
    //         $title.append('<div class="c-red">※ハイフンなしの半角数字で入力してください。</div>');
    //     }
    // });
}

// MyPage
function MyPage() {

    // タイトルを置換
    $('.t_title').text('MYPAGE');

    // アコーディオンを開いておく
    $('.table_collapse_link').removeClass('collapsed').attr('aria-expanded', 'true');
    $('.glyphicon').removeClass('glyphicon-chevron-left').addClass('glyphicon-chevron-down');
    $('.table_collapse').addClass('in');

}

// ご利用ガイド
function fcHelp() {
}

// ログイン
function login() {
    // ログイン方法に関する重要なお知らせを消す
    $('.fc_register_table').hide();

    // ログインのボタン名を置換
    setTimeout(function(){
        $('#LoginBtn').val('LOGIN');
    }, 300);

}

function fcJoinEntry() {
    // 自動継続更新のチェックボクスをonにする
    // $('#card_fc_auto').prop('checked', true);
}

function CustomerEdit() {
}

function fcContact() {
    $('#fc_contact .t_message').each(function(index){
        // お電話でのお問い合わせを非表示にする
        if(index == 0) {
            $(this).hide();
        }
    })
}

function PassEdit() {
}

function PassforgotStep1() {
}

// アコーディオン
$(function () {

    // クラス名定義
    var accordionTitleClass = 'js-accordion-title';
    var accordionBodyClass = 'js-accordion-body';
    var className = 'js-open';

    // titleごとに処理を実行
    $('.' + accordionTitleClass).each(function() {
        var $this = $(this);
        var $body = $this.nextAll('.' + accordionBodyClass);

        // あらかじめクラスが付いていたら初期表示でオープン
        if ($this.hasClass(className)) {
            $body.each( function() {
                $(this).show();
            });
        }

        // タイトルをクリックしたら開閉する
        $this.on('click', function() {
            $this.toggleClass(className);
            $body.each( function() {
                // $(this).toggleClass(className);
                $(this).slideToggle(250, 'linear');
            });
        });
    });
});

/**
 * カート用のロゴとcssを読み込む
 */
const loadCartSetting = () => {

    //logo変更
    var urlParam = location.search.substring(1);

    if (urlParam) {
        var param = urlParam.split('&');
        var paramArray = [] as any;

        for (let i = 0; i < param.length; i++) {
            var paramItem = param[i].split('=');
            paramArray[paramItem[0]] = paramItem[1];
        }

        var $logo = $("#js-header-logo");
        var $url = $('#commonHeaderLogo').find("a");
        var param_artistcode = paramArray.artist_code;
        var param_scode = paramArray.scode;
        var param_ccode = paramArray.ccode;
        var is_original_css = paramArray.is_original_css;

        if (is_original_css) {

            let RETURN_URL      = "",
                HEADER_LOGO_URL = "",
                ADD_CSS_URL     = "",
                CART_BTN_URL    = "";

            if (TestSite.indexOf(host) > -1) {
                // 開発

                RETURN_URL      = 'http://kokonoshoten.dev09.axdv.me/shop/' + param_artistcode;
                HEADER_LOGO_URL = '//kokonoshoten.dev09.axdv.me/modd/' + param_artistcode + '/images/logo.png';
                ADD_CSS_URL     = '//kokonoshoten.dev09.axdv.me/modd/' + param_artistcode + '/css/' + param_artistcode + '.css';
                CART_BTN_URL    = 'https://store-rev.modd.com/v2/ShoppingCart.aspx?ccode=' + param_ccode + '&artist_code=' + param_artistcode + '&is_original_css=' + is_original_css;

            } else {
                // 本番

                RETURN_URL      = 'https://kokonoshoten.com/shop/' + param_artistcode;
                HEADER_LOGO_URL = '//kokonoshoten.com/modd/' + param_artistcode + '/images/logo.png';
                ADD_CSS_URL     = '//kokonoshoten.com/modd/' + param_artistcode + '/css/' + param_artistcode + '.css';
                CART_BTN_URL    = 'https://cart.kokonoshoten.com/v2/ShoppingCart.aspx?ccode=' + param_ccode + '&artist_code=' + param_artistcode + '&is_original_css=' + is_original_css;

            }

            $url.attr('href', RETURN_URL);
            $logo.attr('src', HEADER_LOGO_URL);

            //css追加
            var style = '<link href="' + ADD_CSS_URL + '" type="text/css" rel="stylesheet">';
            $('head link:first').after(style);

            setTimeout(function(){
                //カートボタンのリンク先変更
                var $cart_btn = $("a#cmnhead_button_cart");
                $cart_btn.attr('href', CART_BTN_URL);
            }, 100)
        }


    }
}